import React from 'react'
import './Footer.css'

const Footer = (props) => {
    return (
        <div className='footer'>
          <p>© 2020 Impulse. All rights reserved.</p>  
        </div>
        
    )
}
export default Footer